import dayjs from 'dayjs';

const LeaveGroupedBar = (data = [], weeks = []) => {
  const xLabels = weeks.map(w => w.label);
  const useDataZoom = weeks.length > 6;

  const series = data.map((user, idx) => {
    const fullName = `${user.profile?.firstName ?? ''} ${user.profile?.lastName ?? ''}`.trim();
    return {
      name: fullName,
      type: 'bar',
      data: weeks.map(w => user[w.label] ?? 0),
      itemStyle: {
        borderRadius: [4, 4, 0, 0]
      },
      label: {
        show: true,
        position: 'top',
        formatter: '{c}', // shows count (value)
        color: '#000',     // or any theme-matching color
        fontSize: 12
      }
    };
  });

  return {
    color: [
      '#6A67CE', '#A8D5BA', '#B39CD0', '#4C9AFF', '#FFA07A',
      '#36B37E', '#6554C0', '#00B8D9', '#FFC400', '#FF5630',
      '#FFAB00', '#79F2C0', '#D291BC', '#C5E384', '#F7A072'
    ],
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params) => {
        const weekLabel = params[0]?.axisValue || '';
        const week = weeks.find(w => w.label === weekLabel);
        const dateRange = week ? `(${dayjs(week.from).format('D MMM')}–${dayjs(week.to).format('D MMM')})` : '';
        const header = `<strong>${weekLabel} ${dateRange}</strong><br/>`;

        const details = params
          .map(p => `${p.marker} ${p.seriesName}: ${p.value} day(s)`)
          .join('<br/>');

        return header + details;
      }
    },
    legend: {
      show: false
    },
    grid: {
      left: 0,
      right: 0,
      bottom: useDataZoom ? 50 : 35,
      top: 30,
      containLabel: true
    },
    dataZoom: useDataZoom
      ? [
        {
          type: 'inside',
          xAxisIndex: 0,
          start: 0,
          end: 100
        },
        {
          type: 'slider',
          xAxisIndex: 0,
          show: false,
          height: 15,
          bottom: 30,
          start: 0,
          end: 100
        }
      ]
      : [],
    xAxis: {
      type: 'category',
      data: xLabels,
      axisLabel: { interval: 0 }
    },
    yAxis: {
      type: 'value',
      name: 'Leave Days',
      min: 0,
      max: 5
    },
    series
  };
};

export default LeaveGroupedBar;
